import type { ReactElement } from 'react';
import React, { cloneElement, useEffect } from 'react';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import type { TActionTrigger, TControlProps } from './models';
import { useFlow } from './hooks/use-flow';
import { getTriggers } from './helpers/get-triggers';

/** Обработчик действий  */
export const Control = <ActionType extends string>({
    action,
    actions,
    children,
    loading = 'disabled',
    middleware,
    sentryDisabled = false,
    settings,
    teamConfig,
    trigger = 'onClick',
    useData,
    ...props
}: TControlProps<ActionType>) => {
    const {
        afterContent,
        beforeContent,
        // TODO: попробовали типизировать namedContainers и вот такая история неявная выходит. IDE не подсвечивает как ошибку, а в терминале есть
        // скорее всего если тут дженерик типизировать, то все станет ок
        // @ts-ignore error TS7022: 'child' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
        content = children,
        loader = content,
    } = useNamedContainers(children);

    const [handleTrigger, isLoading] = useFlow<ActionType>({
        action,
        actions,
        useData,
        middleware,
        teamConfig,
        sentryDisabled,
        ...settings,
        ...props,
    });

    useEffect(() => {
        if (!children) handleTrigger({ trigger: 'mount' });

        // выполняется только на монтирование
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!children) return null;

    const child = (isLoading ? loader : content) as ReactElement;

    return (
        <>
            {!isLoading && beforeContent}
            {cloneElement(child, {
                [loading]: isLoading,
                ...getTriggers({
                    trigger,
                    handleTrigger: e => {
                        (props as Record<string, TActionTrigger>)[trigger as string]?.(e);

                        return handleTrigger(e);
                    },
                }),
                ...props,
            })}
            {!isLoading && afterContent}
        </>
    );
};
